import { makeTranslationHelpers } from '@/hooks/useTranslation';

const { useTranslation: usePageTranslation, Translation: PageTranslation } =
  makeTranslationHelpers('page.discover');

export { usePageTranslation, PageTranslation };
